import type { LucideIcon } from "lucide-react";

export function SettingsHeading({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <div className="flex items-center gap-3">
      <span className="grid size-10 place-items-center rounded-xl bg-lumen-100 text-lumen-700 dark:bg-lumen-900/40 dark:text-lumen-300">
        <Icon size={20} />
      </span>
      <div>
        <h1 className="text-2xl font-bold">{title}</h1>
        <p className="text-sm text-stone-500">{description}</p>
      </div>
    </div>
  );
}
